export function getUserKey(user) {
  if (!user) return null;
  const id = user.email || user.sub || user['custom:sub'] || user['custom:name'] || user.username;
  if (!id) return null;
  return String(id).replace(/[^a-zA-Z0-9-_]/g, '_');
}

export function getFiltersStorageKey(user) {
  const userKey = getUserKey(user);
  return userKey ? `filters:${userKey}` : 'filters';
}

export function getFiltersForUser(user) {
  try {
    const key = getFiltersStorageKey(user);
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.error('Error reading filters from localStorage', err);
    return [];
  }
}

export function setFiltersForUser(user, filtersArray) {
  try {
    const key = getFiltersStorageKey(user);
    localStorage.setItem(key, JSON.stringify(filtersArray || []));
  } catch (err) {
    console.error('Error saving filters to localStorage', err);
  }
}

export function removeFiltersForUser(user) {
  try {
    const key = getFiltersStorageKey(user);
    localStorage.removeItem(key);
  } catch (err) {
    console.error('Error removing filters from localStorage', err);
  }
}
